import { fetchData } from "../../../../utils/Http"
import { serverUrl } from "../../../../utils/Settings"

type Response = Hotelstouch.WebApp.Webshop.PaymentGateway.Api.PaymentGatewayData.Response
type Request = Hotelstouch.WebApp.Webshop.PaymentGateway.Api.PaymentGatewayData.Request

export async function getPaymentGatewayData(params?: Request):Promise<Response>{
    return await fetchData<Response>(`${serverUrl}/api/publicWebShop/getPaymentGatewayData`, params)
}